import React, { useState, createContext, useEffect } from "react";

export const NotificationContext = createContext();

export const NotificationListProvider = (props) => {
  const [notificationList, setNotificationList] = useState([{msg : "Quotation going to expire", quote_id : "#10000"},{msg : "Quotation going to expire", quote_id : "#10012"},{msg : "Quotation going to expire", quote_id : "#10034"},{msg : "Quotation going to expire", quote_id : "#10043"},{msg : "Quotation going to expire", quote_id : "#10067"}]);

  // useEffect(() => {
  //   fetch(`${process.env.REACT_APP_URL}/shop.json`)
  //     .then((response) => response.json())
  //     .then((data) => setNotificationList(data.slice(24, 28)));
  // }, []);
// console.log('notificationList', notificationList)
  return (
    <NotificationContext.Provider value={[notificationList, setNotificationList]}>
      {props.children}
    </NotificationContext.Provider>
  );
};